import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import LaunchIcon from "@mui/icons-material/Launch";

const projects = [
  {
    title: "OG-Interior",
    description: "A landing page built with Html and Css",
    image: "/OG-Interior.png",
    tags: ["Html", "Css", "Bootstrap"],
    githubLink: "https://github.com/theyinda/OG-Interiors",
    liveLink: "https://theyinda.github.io/OG-Interiors/",
    longDescription: "A Landing page for OG-Interior",
  },
  {
    title: "Furniture",
    description: "Ecommerce website built with Html, Css, Javascript and Shopify Liquid Template",
    image: "/furniture.png",
    tags: ["Html", "Css", "Javascript", "Shopify Liquid Template"],
    githubLink: "https://github.com/theyinda/furniture",
    liveLink: "https://yindabeauty.myshopify.com/",
    longDescription: "Ecommerce website for furniture",
  },

  {
    title: "Ibloove",
    description: "A landing page built with Html,Css and Javascript",
    image: "/Ibloove.png",
    tags: ["Html", "Css", "Javascript"],
    liveLink: "https://theyinda.github.io/Ibloove/",
    longDescription: "A Landing page for Ibloove",
  },
  // {
  //   title: "Contact Form",
  //   description: "Contact Form Integration with EmailJs",
  //   image: "/project2.jpg", 
  //   tags: ["React", "MUI", "EmailJs"],
  //   githubLink: "https://github.com/yourusername/project2",
  //   liveLink: "https://project2.com",
  //   longDescription: "Detailed description of the project including features, challenges, and solutions...",
  // },
  // {
  //   title: "Weather App",
  //   description: "Real-time Weather App",
  //   image: "/project3.jpg", // Add your project image
  //   tags: ["React", "MUI", "EmailJs"],
  //   githubLink: "https://github.com/yourusername/project3",
  //   liveLink: "https://project3.com",
  //   longDescription: "Detailed description of the project including features, challenges, and solutions...",
  // },
  // {
  //   title: "Dashboard",
  //   description: "Real-time chat application with modern UI",
  //   image: "/project3.jpg", // Add your project image
  //   tags: ["React", "Socket.io", "MongoDB"],
  //   githubLink: "https://github.com/yourusername/project3",
  //   liveLink: "https://project3.com",
  //   longDescription: "Detailed description of the project including features, challenges, and solutions...",
  // },
];

function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <Box sx={{ py: 12, backgroundColor: "background.default" }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            mb: 8,
            color: "primary.main",
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: "-16px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "60px",
              height: "4px",
              backgroundColor: "primary.main",
            },
          }}
        >
          Projects
        </Typography>

        <Grid container spacing={4}>
          {projects.map((project, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "background.paper",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={project.image}
                  alt={project.title}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" component="h3" gutterBottom>
                    {project.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {project.description}
                  </Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {project.tags.map((tag) => (
                      <Chip
                        key={tag}
                        label={tag}
                        size="small"
                        sx={{
                          backgroundColor: "primary.main",
                          color: "background.paper",
                        }}
                      />
                    ))}
                  </Box>
                </CardContent>
                <CardActions sx={{ p: 2 }}>
                  <Button
                    size="small"
                    startIcon={<GitHubIcon />}
                    href={project.githubLink}
                    target="_blank"
                    sx={{ mr: 1 }}
                  >
                    Code
                  </Button>
                  <Button
                    size="small"
                    startIcon={<LaunchIcon />}
                    href={project.liveLink}
                    target="_blank"
                  >
                    Live Demo
                  </Button>
                  <Button
                    size="small"
                    onClick={() => setSelectedProject(project)}
                    sx={{ ml: "auto" }}
                  >
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Dialog
          open={Boolean(selectedProject)}
          onClose={() => setSelectedProject(null)}
          maxWidth="md"
          fullWidth
        >
          {selectedProject && (
            <>
              <DialogTitle>{selectedProject.title}</DialogTitle>
              <DialogContent>
                <Typography variant="body1">
                  {selectedProject.longDescription}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setSelectedProject(null)}>Close</Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </Container>
    </Box>
  );
}

export default Projects;
